// Small original synthesized soundscape; no third-party recordings or car audio.
export class Sound {
  constructor() {
    this.enabled = false;
  }
  async toggle() {
    if (this.enabled) {
      this.enabled = false;
      this.context?.suspend();
      return false;
    }
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return false;
    if (!this.context) {
      this.context = new Audio();
      this.master = this.context.createGain();
      this.master.gain.value = 0.075;
      this.master.connect(this.context.destination);
      for (const hz of [130.81, 196, 261.63]) {
        const osc = this.context.createOscillator(),
          gain = this.context.createGain();
        osc.type = "sine";
        osc.frequency.value = hz;
        gain.gain.value = 0.05;
        osc.connect(gain).connect(this.master);
        osc.start();
      }
    }
    await this.context.resume();
    this.enabled = true;
    this.chime();
    return true;
  }
  chime() {
    if (!this.enabled) return;
    const c = this.context;
    for (const [i, hz] of [523.25, 659.25, 783.99].entries()) {
      const o = c.createOscillator(),
        g = c.createGain(),
        start = c.currentTime + i * 0.08;
      o.frequency.value = hz;
      g.gain.setValueAtTime(0, start);
      g.gain.linearRampToValueAtTime(0.28, start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, start + 0.65);
      o.connect(g).connect(this.master);
      o.start(start);
      o.stop(start + 0.7);
    }
  }
  visibility(hidden) {
    if (hidden) this.context?.suspend();
    else if (this.enabled) this.context?.resume().catch(() => {});
  }
  dispose() {
    this.context?.close();
  }
}
